import { Trans, useTranslation } from 'react-i18next';

import { Button, Modal, ModalContent, ModalFooter, Typography } from '@client/toolkit';

interface LogoutConfirmModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function LogoutConfirmModal({ open, onCancel, onConfirm }: LogoutConfirmModalProps) {
  const { t: tCommon } = useTranslation();

  const handleCancel = () => {
    onCancel();
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal open={open} onClose={handleCancel}>
      <ModalContent>
        <div className="uppercase text-xs font-semibold p-4 text-center text-white">
          {`${tCommon('confirm')} ${tCommon('logout')}`}
        </div>
        <Typography align="center" className="px-4 py-4 text-white">
          <Trans t={tCommon} i18nKey={'logoutConfirm'} />
        </Typography>
      </ModalContent>
      <ModalFooter className="justify-center">
        <Button color="danger" onClick={handleConfirm}>
          {tCommon('logout')}
        </Button>
        <Button color="primary-dark" onClick={handleCancel}>
          {tCommon('cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
